var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf-viewer-native"},_vm._l((_vm.resolvedPages),function(i){return _c('iframe',{key:`pdf-page-${i}`,staticClass:"pdf-frame",style:(_vm.frameStyle),attrs:{"src":_vm.pageSrc(i),"title":"PDF preview"}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }